module.exports = __webpack_public_path__ + "img/preview-friends.7e9a135f.png";